import {Base} from './base.model';
import {Attributo} from './attributo.model';

export abstract class AttributoValore extends Base   {

  constructor(public id: number,
              public target: number,
              public attributo: Attributo,
              public valore: string) {
    super(id);
  }

  public getLabel() {
    return this.valore;
  }

}
